import { render, staticRenderFns } from "./Tyres.vue?vue&type=template&id=1ca64472&"
import script from "./Tyres.vue?vue&type=script&lang=js&"
export * from "./Tyres.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports